import React, { Fragment } from 'react';

import EmptyState from '@atlaskit/empty-state/empty-state';
import Link from '@atlaskit/link/link';

import noResultsImg from '../../icon-explorer/images/no-results.png';

/**
 * __No results__
 *
 * A component that displays an empty state when no search results are found.
 */
const NoResults = ({ isObjectTile }: { isObjectTile?: boolean }): React.JSX.Element => (
	<EmptyState
		header="No results found"
		description={
			<Fragment>
				If you can't find what you're looking for, try visiting the{' '}
				<Link
					href={
						isObjectTile ? '/components/object/object-tile/examples' : '/components/object/examples'
					}
				>
					example guidelines
				</Link>
				.
			</Fragment>
		}
		imageUrl={noResultsImg}
		imageHeight={146.5}
		imageWidth={160}
	/>
);

export default NoResults;
